<template>
  <div class="home" id="container">
    <TopPanel @onLanguageSelected="setLanguage"/>
    <div class="col-12" style="margin-top: 5em; color: #FFFFFF">
<h3>TIETOSUOJASELOSTE (PRIVACY POLICY)</h3>
<hr>
<UL>
  <LI>Routa -selainsovellus</LI>
  <LI>Routa Ajoneuvo - mobiilisovellus</LI>
  <LI>Routa Työaika - mobiilisovellus</LI>
  <LI>Routa Paving - mobiilisovellus</LI>
  <LI>Routa Liikennemerkit - mobiilisovellus</LI>
  <LI>Routa Forest - mobiilisovellus</LI>
</UL>
<hr>
      <h4>1 TIETOJA ROUTA-JÄRJESTELMÄSTÄ</h4>

Routa -järjestelmä helpottaa ja tehostaa liikkuvan työn seurantaa, raportointia sekä laskutusta. Se soveltuu hyvin esim. tieinfrastruktuurin sekä eri alueiden kunnossapito ja hoitotöihin. Kilometri- sekä työaikapohjainen laskutus edellyttää ajoneuvojen sijainnin seurantaa työtehtävän aikana. Lisäksi sopimusten täytäntöönpanon ja lainsäädännön vuoksi sijaintitietoja käytetään myös osoittamaan, että sopimusten mukaiset työtehtävät on hoidettu ajoissa sekä lainsäädännön mukaisesti. Näkyvyys tulee olla myös mahdollisiin aliurakoitsijoihin. Routaa voidaan käyttää myös kalustonhallintaan, jolloin rekisteri sisältää tietoja ajoneuvoista ja muusta kalustosta sekä niille tehdyistä tarkastuksista, puutteista ja huoltotoimenpiteistä.
Lisäksi Routa-järjestelmää parantaa erilaisten liikkuvien ja maastotöiden turvallisuutta ns. ’kuolleenhenkilönkytkimen’ sekä erilaisten vaaratilanneraporttien ja tarkastusten avulla. Henkilön sijainnin seuranta on sovittava aina voimassaolevan lainsäädännön mukaisesti. Routa-järjestelmän avulla henkilöiden paikannusta käytetään työntekijöiden turvallisuuden varmistamiseen sekä resurssien kohdentaminen oikeaan paikkaan (ks. henkilön paikannuksesta myös https://tietosuoja.fi/usein-kysyttya-tyoelama ).
Routa-järjestelmää voidaan käyttää myös ajoneuvojen ja työajan seurantaan.

      <h4>2 REKISTERINPITÄJÄ</h4>
Routa-järjestelmään kerätyt tiedot omistaa kyseiset tiedot kerännyt järjestelmää käyttävä organisaatio. Järjestelmän kehityksestä, ylläpidosta ja lisensoinnista vastaa Routa Systems Oy.
<br><br>
Rekisterinpitäjä: [Routa-asiakkaan nimi ja y-tunnus]<br>
Yhteystiedot: [Routa-asiakkaan yhteystiedot]<br>
Tietojenkäsittelijä: Routa Systems Oy (3019045-8)<br>

      <h4>3 YHTEYSHENKILÖ</h4>
Rekisterinpitäjän yhteyshenkilö: [nimi]<br>
Sähköposti: [sähköpostiosoite]<br>

      <h4>4 HENKILÖTIETOJEN KÄSITTELYN TARKOITUKSET JA OIKEUSPERUSTE</h4>
Sovelluksen käyttäjärekisterin käyttötarkoituksena on kerätä tietoa liikkuvasta työstä liiketoimintaan liittyvää laskutusta, lakisääteisten vaatimusten toteuttamista, palkanmaksua sekä maastotyön turvallisuuden parantamista varten.<br>
Käsittely on tarpeen sopimuksen täytäntöön panemiseksi, jossa rekisteröity on osapuolena, tai sopimuksen tekemistä edeltävien toimenpiteiden toteuttamiseksi rekisteröidyn pyynnöstä.<br>
Käsittely on tarpeen rekisterinpitäjän lakisääteisen velvoitteen noudattamiseksi.<br>
Käsittely on tarpeen rekisteröidyn tai toisen luonnollisen henkilön elintärkeiden etujen suojaamiseksi.<br>

      <h4>5 REKISTERISSÄ KÄSITELTÄVÄT HENKILÖTIEDOT</h4>
Järjestelmän käyttö edellyttää käyttäjätiliä. Käyttäjätili sisältää aina seuraavat henkilötiedot:<br>
- Nimi<br>
- Yhteystiedot (sähköposti, puhelinnumero)<br>

Lisäksi henkilöstä voidaan tallettaa seuraavat tiedot:<br>
- Suoritetut koulutukset ja niiden voimassaolo<br>
- Henkilön kuljettaman ajoneuvon sijainti (location data) ja reitti<br>
- Henkilön sijainti (location data) työn aikana (seurannasta sovittava erikseen lain mukaisen käyttötapauksen perusteella henkilöstön kanssa)<br>
- Työt, työmaat tai urakat ja asiakkuudet, joille työtä tehdään<br>

      <h4>6 MISTÄ HENKILÖTIEDOT ON SAATU?</h4>
Rekisterin henkilötietoja kerätään suoraan rekisteröidyltä itseltään tai rekisteröidyn työn- tai toimeksiantajalta. Järjestelmän sovellukset keräävät ajoneuvojen reittitietoja automaattisesti ja käyttötapauksen mukaan myös työntekijän sijaintitietoa kerätään sovelluksissa automaattisesti. Sijaintitietoa kerätään ainoastaan silloin, kun henkilö on sovellukseen kirjautunut ja/ tai merkinnyt itsensä töihin.<br>

      <h4>7 TIETOJEN ANTAMINEN JA ANTAMATTA JÄTTÄMISEN SEURAUKSET</h4>
Henkilötietojen antaminen on välttämätöntä järjestelmän käyttämiseksi työn sekä työajanseurantaan ja turvallisuuden parantamiseen.<br>

      <h4>8 AUTOMAATTINEN PÄÄTÖKSENTEKO JA PROFILOINTI</h4>
Järjestelmä ei suorita profilointia tai automaattista päätöksentekoa henkilötietojen osalta.<br>

      <h4>9 HENKILÖTIETOJEN VASTAANOTTAJAT JA VASTAANOTTAJARYHMÄT</h4>
Rekisterin tietoja voidaan luovuttaa järjestelmään käyttävän yhtiön asiakkaille sekä viranomaisille lain puitteissa. Myös järjestelmää käyttävän yhtiön asiakkaille voidaan luovuttaa tietoja silloin, kun yhtiöllä ja asiakkaalla on yhteinen urakka- tai työmaa. Henkilötietoja voidaan käyttää työhön tai turvallisuuteen liittyvien asioiden hoitamisessa.<br>
Henkilötietoja ei luovuteta tai käytetä markkinointitarkoituksiin.<br>

      <h4>10 TIETOJEN SIIRTO KOLMANIIN MAIHIN (EU/ETA-ALUEEN ULKOPUOLELLE)</h4>
Tämän rekisterin tiedot säilytetään EU/ETA-alueella, eikä tämän rekisterin henkilötietoja ei siirretä EU/ETAalueen ulkopuolelle järjestelmän kehittäjän Routa Systems Oy:n toimesta.<br>
Järjestelmä hyödyntää kolmannen osapuolen ohjelmistoja ja näiden kolmansien osapuolten ohjelmistojen käyttöön liittyviä tietoja voidaan käsitellä myös EU-alueen ulkopuolella. Em. kolmansia osapuolia ovat mm.<br>
- HERE – Kartta- ja sijaintipalvelut<br>
- Google – Android käyttöjärjestelmä, Google Play -sovelluskauppa, Firebase Cloud Messaging notifikaatioissa<br>

      <h4>11 HENKILÖTIETOJEN SÄILYTYSAIKA</h4>
Henkilötietoja säilytetään rekisterissä niin kauan kun henkilö on järjestelmän käyttäjä tai tietoja on järjestelmän asiakkaan puolesta oleellista säilyttää esim. vahingonkorvausvaatimusten varalta. Kuitenkin vähintään 5 vuotta.<br>
Järjestelmän kehittäjä ja ylläpitäjä voi poistaa käyttämättömiä tietoja järjestelmästä niiden yhtiöiden osalta, joiden lisenssisopimus on päättynyt.<br>

      <h4>12 REKISTERÖIDYN OIKEUDET</h4>
Rekisteröidyllä on seuraavat oikeudet koskien tässä rekisterissä oleva henkilötietojansa.<br>
1) Rekisteröidyllä on oikeus saada pääsy häntä koskeviin henkilötietoihin tässä rekisterissä, mikäli oikeuksia pyytävä henkilö pystytään luotettavasti tunnistamaan rekisteröidyksi. Tätä oikeutta käyttävän rekisteröidyn pyynnöstä rekisterinpitäjä toimittaa rekisteröidylle otteen niistä henkilötiedoista, joita rekisterissä on.<br>
2) Rekisteröidyllä on oikeus pyytää omien henkilötietojensa oikaisua, mikäli niissä on virheellisiä, epätarkkoja tai vanhentuneita tietoja<br>
3) Rekisteröidyllä on oikeus peruuttaa suostumus henkilötietojensa käsittelyyn, mikäli suostumus on pyydetty tietoja kerättäessä rekisteröidyltä itseltään.<br>
4) Rekisteröidyllä on oikeus saada henkilötietonsa poistettua (”oikeus tulla unohdetuksi”). Henkilötiedot poistetaan, kun <br>
	a. Henkilötietojen käsittelylle ei ole enää tarvetta<br>
	b. Henkilötietoja on käsitelty lainvastaisesti<br>
5) Rekisteröidyllä on oikeus henkilötietojensa käsittelyn rajoittamiseen, mikäli<br>
	a. rekisteröity kiistää henkilötietojen paikkansapitävyyden, jolloin käsittelyä rajoitetaan ajaksi, jonka kuluessa rekisterinpitäjä voi varmistaa niiden paikkansapitävyyden<br>
	b. käsittely on lainvastaista ja rekisteröity vastustaa henkilötietojen poistamista ja vaatii sen sijaan niiden käytön rajoittamista<br>
	c. rekisterinpitäjä ei enää tarvitse kyseisiä henkilötietoja käsittelyn tarkoituksiin, mutta rekisteröity tarvitsee niitä oikeudellisen vaateen laatimiseksi, esittämiseksi tai puolustamiseksi<br>
6) Rekisteröidyllä on oikeus saada häntä koskevat henkilötiedot, jotka hän on toimittanut rekisterinpitäjälle, jäsennellyssä, yleisesti käytetyssä ja koneellisesti luettavassa muodossa, ja oikeus siirtää kyseiset tiedot toiselle rekisterinpitäjälle.<br>
7) Rekisteröidyllä on oikeus tehdä valitus valvontaviranomaiselle.<br>

      <h4>13 MUUTOKSET</h4>
Tämä tietosuojaseloste on päivitetty viimeksi 24.11.2022. Aiemman version tietosuojaselosteesta voi pyytää rekisterinpitäjältä, ks. rekisterinpitäjän yhteystiedot.<br>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import TopPanel from "@/components/TopPanel";
import Footer from "@/components/Footer";

export default {
  name: 'termsText',
  components: {
    Footer,
    TopPanel
  },
  data () {
    return {
      locale: this.getLanguage(),
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  },
  methods: {
    setLanguage: function (lang) {
      this.locale = lang
    },
    getLanguage: function () {
      let lang = navigator.language.split('-')[0]
      switch (lang) {
        case 'en':
          return 'en'
        case 'fi':
          return 'fi'
        case 'fr':
          return 'fr'
      }
      return 'en'
    },
    openFileFromAssets: function (record) {
      window.open(record.link,'_blank');
    }
  }
}
</script>
